import { createSlice } from "@reduxjs/toolkit";
 
 
const userReducer = createSlice({
  name: "user",
  initialState: {     
    userLoading:false,
    userLogin:false,
    userLoginModal:false,
    userWishList:[] ,    
  },

  reducers: {          
    setUserLoading(state, action) {      
      state.userLoading = !state.userLoading
    },    
    setUserLogin(state, action) {      
      state.userLogin = !state.userLogin
    },
    setUserLoginModal(state, action) {      
      state.userLoginModal = !state.userLoginModal
    }, 
    setUserWishList(state, action) {      
      state.userWishList = action?.payload
    },     
  },
});

export const {
    setUserLoading,setUserLogin,setUserLoginModal,
    setUserWishList,
} = userReducer.actions;
export default userReducer.reducer;
